import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MenuGroup } from '../../dynamic-input-model';
import { NbMenuService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';

@Component({
  selector: 'ngx-header-input',
  templateUrl: './header-input.component.html',
  styleUrls: ['./header-input.component.scss']
})
export class HeaderInputComponent implements OnInit {
  @Input() data:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editHeaderMenu";
  //Used in ngSwitch to select content to show without click event.
  defaultInputMenuItem:string;
  //activeInputMenuItem: Used in ngSwitch to select content to show.  Triggered by menu click.
  activeInputMenuItem:string;
  menuGroups:any;
  //selectedMenuItem = 
  menuItemTitle:string;

  

  constructor(
    private el:ElementRef, 
    private menuService:NbMenuService) { }


  ngOnInit(): void {
    this.menuGroups = this.data;
    console.log(this.menuGroups);
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];
    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        console.log({selectedItem:selectedItem});
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    let host = <HTMLElement>this.el.nativeElement;
    let radioGroupCollections = host.getElementsByTagName("nb-radio-group");
    if(radioGroupCollections != null && radioGroupCollections != undefined && radioGroupCollections.length > 0){
      let radioGroupCollection = radioGroupCollections[0];
      for(let i = 0; i < radioGroupCollection.children.length; i++){
        let nb_radio = radioGroupCollection.children[i];
        let nb_radio_child = <HTMLElement>nb_radio.children[0];
        nb_radio_child.style.setProperty('padding','0')
        //nb_radio_child.classList.add("tight");
        /* let _label = nb_radio_child.children[0];
        console.log(_label);
        _label.classList.add("tight"); */
        //host.style.setProperty('--header-height',headerHost.offsetHeight+"px");
      }
    }
  }

  tabChanged(e){

  }

}
